import { useLanguageContext } from "state/languageState/languageContext";

/**
 * Navigation is refused while the language settles, since the change remounts the app. Read
 * imperatively, not as a hook: `window.pushPath` is assigned once and must see the value at
 * call time.
 */
export const isChangingLanguage = () => useLanguageContext.getState().pendingLanguage !== null;
